/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { Card, CardBody, Flex, Button, CardHeader } from "@chakra-ui/react";
import { DatePicker, Form, FormField, FormItem, FormControl } from "@repo/ui";
import { useGetUserProfile, useUpdateProfile } from "services/auth";
import Loader from "ui/page-loader";
import { BreadCrumb } from "ui/bread-crumbs";
import FormInput from "ui/Input";
import { Label } from "ui/label";
import { PATHS } from "../../routes/paths";

export default function Profile() {
  const [currentTab, setCurrentTab] = useState("personalInformation");
  const [enableEditing, setEnableEditing] = useState(false);
  const navigate = useNavigate();
  const {
    mutate: getProfile,
    data: profileRes,
    isPending: gettingProfile,
  } = useGetUserProfile();
  const {
    mutate: updateProfile,
    data: updateProfileRes,
    isPending: updatingProfile,
    reset: updateProfileReset,
  } = useUpdateProfile();
  const form = useForm({
    defaultValues: {
      dateOfBirth: null,
      dateOfJoining: null,
      nationalIdExpiry: null,
      passportExpiry: null,
      drivingLicenseExpiry: null,
    },
  });
  const generalFieldProps = {
    control: form.control,
    errors: form.formState.errors,
  };

  useEffect(() => {
    if (profileRes?.data) {
      const _data = { ...profileRes.data };
      const _user = {
        ..._data,
        dateOfJoining: _data.dateOfJoining
          ? new Date(_data.dateOfJoining)
          : null,
        dateOfBirth: _data.dateOfBirth ? new Date(_data.dateOfBirth) : null,
        nationalIdExpiry: _data.nationalIdExpiry
          ? new Date(_data.nationalIdExpiry)
          : null,
        passportExpiry: _data.passportExpiry
          ? new Date(_data.passportExpiry)
          : null,
        drivingLicenseExpiry: _data.drivingLicenseExpiry
          ? new Date(_data.drivingLicenseExpiry)
          : null,
      };

      form.reset(_user);
    }

    if (updateProfileRes) {
      setEnableEditing(false);
      updateProfileReset();
      navigate("/");
    }
  }, [profileRes, updateProfileRes]);
  useEffect(() => {
    getProfile();
  }, []);
  const onSubmit = (data) => {
    updateProfile({ ...data });
  };
  return (
    <>
      {gettingProfile || updatingProfile ? <Loader /> : <></>}

      <div className="form-container-2">
        <BreadCrumb
          className="mx-4 my-2"
          items={[{ text: "Profile", isCurrentPage: true }]}
        />
        <Flex w="100%" style={{ gap: "4%" }}>
          <Card style={{ width: "26%", minWidth: "26%" }}>
            <CardBody>
              <div className="profile-side-bar-col">
                <div
                  className="tab"
                  onClick={() => {
                    setCurrentTab("personalInformation");
                  }}
                >
                  Personal Information
                </div>
                <div
                  className="tab"
                  onClick={() => {
                    setCurrentTab("employeeInformation");
                  }}
                >
                  Employee Information
                </div>

                <div className="tab">
                  <Link to={PATHS.changePassword}>Change Password </Link>
                </div>
              </div>
            </CardBody>
          </Card>
          <Card w="70%">
            <CardHeader>
              {currentTab === "employeeInformation"
                ? "Employee Information"
                : "Personal Information"}
            </CardHeader>
            <CardBody>
              <Form {...form}>
                <form
                  onSubmit={form.handleSubmit(onSubmit)}
                  className="profile-form"
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-end",
                      justifyContent: "flex-end",
                      width: "100%",
                    }}
                  >
                    <Button
                      onClick={() => {
                        if (enableEditing) {
                          form.reset(profileRes.data);
                        }
                        setEnableEditing(!enableEditing);
                      }}
                    >
                      {enableEditing ? "Cancel Editing" : "Edit"}
                    </Button>
                    {enableEditing ? (
                      <Button type="submit" style={{ marginLeft: "12px" }}>
                        Update
                      </Button>
                    ) : (
                      <></>
                    )}
                  </div>
                  {currentTab === "employeeInformation" ? (
                    <>
                      <FormInput
                        {...generalFieldProps}
                        name="employeeId"
                        label="Employee ID"
                        inputProps={{ readOnly: true }}
                        hideIcons
                      />
                      <FormInput
                        {...generalFieldProps}
                        name="designation"
                        label="Designation"
                        inputProps={{ readOnly: true }}
                        hideIcons
                      />
                      <FormField
                        control={form.control}
                        name="dateOfJoining"
                        render={({ field }) => (
                          <FormItem>
                            <Label label="Date of Joining" />
                            <FormControl>
                              <DatePicker
                                selectedDate={field.value}
                                disabled={!enableEditing}
                                placeholder="Date of Joining"
                                onSelectDate={field.onChange}
                              />
                            </FormControl>
                          </FormItem>
                        )}
                      />
                    </>
                  ) : (
                    <>
                      <FormInput
                        {...generalFieldProps}
                        name="firstName"
                        label="First Name"
                        inputProps={{ readOnly: true }}
                        hideIcons
                      />
                      <FormInput
                        {...generalFieldProps}
                        name="lastName"
                        label="Last Name"
                        inputProps={{ readOnly: true }}
                        hideIcons
                      />
                      <FormInput
                        {...generalFieldProps}
                        name="email"
                        label="Email"
                        inputProps={{ readOnly: true }}
                        hideIcons
                      />
                      <FormInput
                        {...generalFieldProps}
                        name="personalEmail"
                        label="Personal Email"
                        inputProps={{ readOnly: !enableEditing }}
                        hideIcons
                      />
                      <FormInput
                        {...generalFieldProps}
                        name="mobileNo"
                        label="Mobile No"
                        inputProps={{ readOnly: !enableEditing }}
                        hideIcons
                      />
                      <FormInput
                        {...generalFieldProps}
                        name="personalMobileNo"
                        label="Personal Mobile No"
                        inputProps={{ readOnly: !enableEditing }}
                        hideIcons
                      />
                      <FormField
                        control={form.control}
                        name="dateOfBirth"
                        render={({ field }) => (
                          <FormItem>
                            <Label label="Date of Birth" />
                            <FormControl>
                              <DatePicker
                                selectedDate={field.value}
                                disabled={!enableEditing}
                                placeholder="Date of Birth"
                                onSelectDate={field.onChange}
                              />
                            </FormControl>
                          </FormItem>
                        )}
                      />
                      <FormInput
                        {...generalFieldProps}
                        name="nationalId"
                        label="National ID"
                        inputProps={{ readOnly: !enableEditing }}
                        hideIcons
                      />
                      <FormField
                        control={form.control}
                        name="nationalIdExpiry"
                        render={({ field }) => (
                          <FormItem>
                            <Label label="National ID Expiry" />
                            <FormControl>
                              <DatePicker
                                selectedDate={field.value}
                                disabled={!enableEditing}
                                placeholder="National ID Expiry"
                                onSelectDate={field.onChange}
                              />
                            </FormControl>
                          </FormItem>
                        )}
                      />
                      <FormInput
                        {...generalFieldProps}
                        name="passportNo"
                        label="Passport No"
                        inputProps={{ readOnly: !enableEditing }}
                        hideIcons
                      />
                      <FormField
                        control={form.control}
                        name="passportExpiry"
                        render={({ field }) => (
                          <FormItem>
                            <Label label="Passport Expiry" />
                            <FormControl>
                              <DatePicker
                                selectedDate={field.value}
                                disabled={!enableEditing}
                                placeholder="Passport Expiry"
                                onSelectDate={field.onChange}
                              />
                            </FormControl>
                          </FormItem>
                        )}
                      />
                      <FormInput
                        {...generalFieldProps}
                        name="drivingLicenseNo"
                        label="Driving License No"
                        inputProps={{ readOnly: !enableEditing }}
                        hideIcons
                      />
                      <FormField
                        control={form.control}
                        name="drivingLicenseExpiry"
                        render={({ field }) => (
                          <FormItem>
                            <Label label="Driving License Expiry" />
                            <FormControl>
                              <DatePicker
                                selectedDate={field.value}
                                disabled={!enableEditing}
                                placeholder="PDriving License Expiry"
                                onSelectDate={field.onChange}
                              />
                            </FormControl>
                          </FormItem>
                        )}
                      />
                    </>
                  )}
                </form>
              </Form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
